if(document.querySelector('.size-guide-popup') && document.querySelector('.view-size-guide')) {
  if(document.querySelector('.size-guide-popup .content').innerText.length < 1) {

    let pageHandle = document.querySelector('.view-size-guide').dataset.sizeGuidePage;

    fetch(window.Shopify.routes.root + 'pages/' + pageHandle)
      .then(function(response) {
        // When the page is loaded convert it to text
        return response.text()
      })
      .then(function(html) {

        let div = document.createElement('div');
        div.innerHTML = html;

        let content = div.querySelector('#main-content');

        //document.querySelector('.size-guide-popup .content').innerHTML = content.innerHTML;
      })
      .catch(function(err) {
        console.log('Failed to fetch page: ', err);
      });

  }
}

(() => {
  const exclusionText = ' (excludes sale)';

  const updateGlobalEFreeShippingBanner = () => {
    const banner = document.querySelector('#FreeShippingBanner');

    if (!banner || banner.textContent.includes(exclusionText)) {
      return;
    }

    banner.textContent = `${banner.textContent.trim()}${exclusionText}`;
  };

  updateGlobalEFreeShippingBanner();

  const observer = new MutationObserver(updateGlobalEFreeShippingBanner);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();

if(document.querySelector('.view-size-guide')) {
  document.querySelector('.view-size-guide').addEventListener('click', (e) => {
    e.preventDefault();
    openSizeGuidePopup();
  });
}

if(document.querySelector('.size-guide-popup-container .close')) {
  document.querySelector('.size-guide-popup-container .close').addEventListener('click', (e) => {
    closeSizeGuidePopup();
  });
}

if(document.querySelector('.size-guide-popup-container')) {
  document.querySelector('.size-guide-popup-container').addEventListener('click', (e) => {
    if(!e.target.closest('.size-guide-popup')) {
      closeSizeGuidePopup();
    }
  });
}

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    const sizeGuidePopup = document.querySelector('.size-guide-popup-container');
    if (sizeGuidePopup && sizeGuidePopup.classList.contains('active')) {
      closeSizeGuidePopup();
    }
  }
});

function handleTabNavigation(dialog, firstFocusableElement, lastFocusableElement) { 
  dialog.addEventListener('keydown', function(e) {
    if (e.defaultPrevented || dialog.id === 'mobile-menu') {
      return;
    }
    // Function to get current last focusable element, accounting for disabled state

    const getLastFocusableElement = () => {
      if (lastFocusableElement && !lastFocusableElement.disabled) {
        return lastFocusableElement;
      }

      // Find all focusable elements in the dialog that aren't disabled
      const focusableElements = dialog.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])');
      return focusableElements[focusableElements.length - 1];
    };

    if(e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
      e.preventDefault();
      const currentLastFocusable = getLastFocusableElement();
      if (currentLastFocusable) {
        currentLastFocusable.focus();
      }
    } else if(e.target == getLastFocusableElement() && e.key == 'Tab' && !e.shiftKey) {
      e.preventDefault();
      firstFocusableElement.focus();
    }
  });
}


let sizeGuideTrigger = null;

function openSizeGuidePopup() {
  sizeGuideTrigger = document.activeElement || document.querySelector('.view-size-guide');
  let target = document.querySelector('.size-guide-popup-container');
  lockModalScroll();
  target.classList.add('active');
}

function closeSizeGuidePopup() {
  let target = document.querySelector('.size-guide-popup-container');
  target.classList.remove('active');
  if (sizeGuideTrigger) {
    sizeGuideTrigger.focus();
  }
  unlockModalScroll();
}

function lockModalScroll() {
  const scrollPosition = window.scrollY || document.documentElement.scrollTop;
  document.documentElement.style.setProperty('--modal-scroll-top', `-${scrollPosition}px`);
  document.body.style.setProperty('--modal-scroll-top', `-${scrollPosition}px`);
  document.documentElement.dataset.modalScrollPosition = scrollPosition;
  document.documentElement.classList.add('modal-scroll-locked');
  document.body.classList.add('modal-scroll-locked');
}

function unlockModalScroll() {
  const scrollPosition = Number(document.documentElement.dataset.modalScrollPosition) || 0;
  document.documentElement.classList.remove('modal-scroll-locked');
  document.body.classList.remove('modal-scroll-locked');
  document.documentElement.style.removeProperty('--modal-scroll-top');
  document.body.style.removeProperty('--modal-scroll-top');
  delete document.documentElement.dataset.modalScrollPosition;
  window.scrollTo(0, scrollPosition);
}

document.querySelectorAll('.custom-video-section .custom-video-wrapper').forEach(($video_block) => {
  const $video = $video_block.querySelector('.custom-video');
  const $video_cover = $video_block.querySelector('.cover-image');
  const $video_player = $video_block.querySelector('.video-player');

  if ($video && $video_player) {
    $video_player.addEventListener('ended', () => {
      $video.classList.remove('active');
      $video_player.controls = false;
    });

    $video_cover.addEventListener('click', () => {
      $video.classList.add('active');
      $video_player.currentTime = 0;
      $video_player.controls = true;
      $video_player.play();
    });
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Enter') {
    const quickViewElements = document.querySelectorAll('.product-card-quickview');
    const cartIcon = document.querySelector('a.thb-secondary-area-item.thb-secondary-cart');
    quickViewElements.forEach(quickViewElement => {
      if (document.activeElement === quickViewElement) {
        quickViewElement.click();
      }
    });

    if (document.activeElement === cartIcon) {
      cartIcon.click();
      setTimeout(() => {
        document.querySelector('.cart-drawer side-panel-close').focus();
      }, 400);
    }

  }
});

if (document.querySelector('.announcement-bar')) {
  const announcementBarSection = document.querySelector('.announcement-bar-section');
  announcementBarSection.setAttribute('role','region');
  announcementBarSection.setAttribute('aria-label','promotional banner');
}

function fixFastSimonAccessibility() {
  const observeShadowRoot = (shadowRoot) => {
    const observer = new MutationObserver(() => {
      // 1. Fix Issue #33: QUICK VIEW button (make it act as a button)
      const qvContainers = shadowRoot.querySelectorAll('.classic-quick-view-container:not([role="button"])');
      qvContainers.forEach((container) => {
        container.setAttribute('role', 'button');
        container.setAttribute('tabindex', '0');
        container.setAttribute('aria-label', 'Quick View');
        
        // Add keydown handler
        container.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            container.click();
          }
        });
      });

      // 2. Fix Issue #31: Card headings (mark up product name as heading)
      const qvNames = shadowRoot.querySelectorAll('.fs-recommendation-product-name-wrapper:not(h4)');
      qvNames.forEach((span) => {
        const h4 = document.createElement('h4');
        h4.className = span.className;
        h4.style.fontSize = 'inherit';
        h4.style.fontFamily = 'inherit';
        h4.style.fontWeight = 'inherit';
        h4.style.margin = '0';
        h4.style.display = 'inline';
        h4.textContent = span.textContent;
        span.parentNode.replaceChild(h4, span);
      });
    });

    observer.observe(shadowRoot, { childList: true, subtree: true });
  };

  const widgetContainer = document.querySelector('.fast-simon-new-upsell-17612302990648321');
  if (widgetContainer) {
    if (widgetContainer.shadowRoot) {
      observeShadowRoot(widgetContainer.shadowRoot);
    } else {
      const originalAttachShadow = HTMLElement.prototype.attachShadow;
      HTMLElement.prototype.attachShadow = function (options) {
        const shadowRoot = originalAttachShadow.call(this, options);
        if (this.classList.contains('fast-simon-new-upsell-17612302990648321')) {
          observeShadowRoot(shadowRoot);
        }
        return shadowRoot;
      };
    }
  } else {
    const originalAttachShadow = HTMLElement.prototype.attachShadow;
    HTMLElement.prototype.attachShadow = function (options) {
      const shadowRoot = originalAttachShadow.call(this, options);
      if (this.classList.contains('fast-simon-new-upsell-17612302990648321')) {
        observeShadowRoot(shadowRoot);
      }
      return shadowRoot;
    };
  }
}

document.addEventListener("DOMContentLoaded", (event) => {
  fixFastSimonAccessibility();
  let elapsedTime = 0;
  const interval = setInterval(() => {
    const cookiesBanner = document.querySelector('#onetrust-consent-sdk');
    const skipContentElement = document.querySelector('.screen-reader-shortcut');

    if (cookiesBanner && skipContentElement) {
      cookiesBanner.setAttribute('role', 'region');
      cookiesBanner.setAttribute('aria-label', 'Cookie consent banner');
      skipContentElement.insertAdjacentElement('afterend', cookiesBanner);
      clearInterval(interval);
    }

    elapsedTime += 100;

    if (elapsedTime >= 4000) {
      clearInterval(interval);
    }
  }, 300);

  if (document.querySelector('#footer')) {
    window.addEventListener('load', updateElement);
    window.addEventListener('resize', updateElement);
  }

  function updateElement() {
    const elements = document.querySelectorAll('#footer button.collapsible');

    if (elements.length === 0) return;

    elements.forEach((element) => {
      if (window.innerWidth >= 1000) {
        if (element.tagName === 'BUTTON') {
          const newHeading = document.createElement('h2');
          newHeading.innerHTML = element.innerHTML;
          newHeading.className = element.className;
          element.parentNode.replaceChild(newHeading, element);
        }
      } else {
        if (element.tagName === 'H2') {
          const newButton = document.createElement('button');
          newButton.innerHTML = element.innerHTML;
          newButton.className = element.className;
          element.parentNode.replaceChild(newButton, element);
        }
      }
    });
  }

  if (document.querySelector('.shopify-policy__body')) {
    const tablesTh = document.querySelectorAll('.shopify-policy__body table th');
    tablesTh.forEach((th) => {
      th.setAttribute('scope','col');
    });
  }

  if (!window.__akiraDynamicCheckoutHrefFixInitialized) {
    window.__akiraDynamicCheckoutHrefFixInitialized = true;

    const fixDynamicCheckoutLinks = () => {
      const paymentLinks = document.querySelectorAll('.shopify-payment-button a:not([href]), .shopify-payment-button a[href=""], .shopify-payment-button a[href="#"], .shopify-payment-button a[href="javascript:void(0)"], .shopify-payment-button__more-options');

      paymentLinks.forEach((link) => {
        link.setAttribute('href', '#More-Payment-Options');
      });
    };

    fixDynamicCheckoutLinks();

    const paymentButtonObserver = new MutationObserver(fixDynamicCheckoutLinks);
    paymentButtonObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (window.location.href.includes("rewards")) {
    const findHiwImages = setInterval(() => {
      const hiwImages = document.querySelectorAll('.hiw .hiw_main img');

      if (hiwImages.length === 3) {
        const altTexts = [
          "Step 1 - Become a member",
          "Step 2 - Earn Points",
          "Step 3 - Redeem Points"
        ];

        hiwImages.forEach((image, index) => {
          image.setAttribute('alt', altTexts[index]);
        });

        clearInterval(findHiwImages);
      }
    }, 300);
}

  if (document.querySelector('.custom-video .cover-image')) {
    const customVideoCoverImages = document.querySelectorAll('.custom-video .cover-image');;

    customVideoCoverImages.forEach((image => {
      image.setAttribute('alt','');
    }));
  }

  const lionNotificationInterval = setInterval(() => {
    const lionNotification = document.querySelector('.lion-notification-container');
    if (lionNotification) {
      lionNotification.setAttribute('role', 'status');
      clearInterval(lionNotificationInterval);
    }
  }, 300);

  setTimeout(() => {4
    clearInterval(lionNotificationInterval);
  }, 3000);

  if (document.querySelector('.product-single__media-zoom')) {
    document.querySelectorAll('.product-single__media-zoom').forEach((zoomButton) => {
      zoomButton.addEventListener('click', () => {
          setTimeout(() => {
      
              var dialog = document.querySelector('.pswp');
              var firstFocusableElement = dialog.querySelector('.pswp__button--close');
              var lastFocusableElement = dialog.querySelector('.pswp__button--arrow--right');
  
              handleTabNavigation(dialog, firstFocusableElement, lastFocusableElement);
  
              const allPdpImages = document.querySelectorAll('.product-single__media.product-single__media-image img');
              const pswpZoomImages = document.querySelectorAll('.pswp__zoom-wrap .pswp__img');
  
              const scrollWrap = document.querySelector('.pswp__scroll-wrap');
              if (scrollWrap) {
                  const carouselDiv = document.createElement('div');
                  carouselDiv.setAttribute('role', 'region');
                  carouselDiv.setAttribute('aria-label', 'carousel');
                 
                  scrollWrap.parentNode.insertBefore(carouselDiv, scrollWrap);
                  carouselDiv.appendChild(scrollWrap);
              }
          }, 500);
      });
    });
  }

  if (document.querySelector('.view-size-guide')) {
    document.querySelector('.view-size-guide').addEventListener('click', (e) => {
      e.preventDefault();
      setTimeout(() => {
        document.querySelector('.size-guide-popup .close').focus();
      }, 500);

      var dialog = document.querySelector('.size-guide-popup-container[role="dialog"]');
      if (!dialog) return;

      var firstFocusableElement = dialog.querySelector('.close');
      var focusableElements = dialog.querySelectorAll('a');
      var lastFocusableElement = focusableElements[focusableElements.length - 1] || firstFocusableElement;

      if (firstFocusableElement) {
        handleTabNavigation(dialog, firstFocusableElement, lastFocusableElement);
      }
    });
  }


  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      if (document.activeElement.classList.contains('slideshow__slide-content-link') ||
        document.activeElement.classList.contains('pswp__button--arrow--right') ||
        document.activeElement.classList.contains('pswp__button--arrow--left') ||
        document.activeElement.classList.contains('size_selector')) {
        document.activeElement.click();
      }

      if (document.querySelector('.view-size-guide') && document.activeElement.classList.contains('close')) {
        document.activeElement.click();
        document.querySelector('.view-size-guide').focus();
      }

      if (document.querySelector('store-availability-drawer') && document.activeElement.classList.contains('store-availability')) {
        document.activeElement.click();
        document.querySelector('.size-selector-label:not([disabled])').focus();

        var dialog = document.querySelector('.store-availability-drawer[role="dialog"]');
        var firstFocusableElement = dialog.querySelector('.side-panel-close');
        var sizeButton = dialog.querySelector('#size_selector_button');
        var sizeSelectors = dialog.querySelectorAll('.size-selector-label:not([disabled])');
        var lastSizeSelector = sizeSelectors[sizeSelectors.length - 1];

        // Set initial last focusable element based on button state
        var lastFocusableElement = !sizeButton.disabled ? sizeButton : lastSizeSelector;

        // Add a mutation observer to handle changes to the button's disabled state
        const observer = new MutationObserver(() => {
          // Update the last focusable element when button state changes
          lastFocusableElement = !sizeButton.disabled ? sizeButton : lastSizeSelector;
        });

        if (sizeButton) {
          observer.observe(sizeButton, {
            attributes: true,
            attributeFilter: ['disabled']
          });
        }

        // Custom tab navigation for this specific drawer
        dialog.addEventListener('keydown', function(e) {
          if(e.key === 'Tab') {
            if(e.target === firstFocusableElement && e.shiftKey) {
              e.preventDefault();
              lastFocusableElement.focus();
            } else if(e.target === lastFocusableElement && !e.shiftKey) {
              e.preventDefault();
              firstFocusableElement.focus();
            }
          }
        });
      }

      if (document.querySelector('store-availability-drawer') && document.activeElement.classList.contains('side-panel-close')) {
        document.querySelector('.store-availability').focus();
      }

      if (document.activeElement.classList.contains('size-selector-label')) {
        document.activeElement.previousElementSibling.click();
      }

      if (document.activeElement.classList.contains('pswp__button--close')) {
        document.activeElement.click();
        document.querySelector('.product-single__media-zoom').focus();
      }
    }
  });


  if (document.querySelector('.search-results') || document.querySelector('#fs-ssr-app-content')) {
    //Wrap pagination links in a <nav>
    const findPaginationWrapper = setInterval(() => {
      const paginationWrapper = document.querySelector('.pagination-wrapper');
      if (paginationWrapper) {
        const navElement = document.createElement('nav');
        navElement.setAttribute('aria-label', 'pagination');
        paginationWrapper.parentNode.insertBefore(navElement, paginationWrapper);
        navElement.appendChild(paginationWrapper);
        clearInterval(findPaginationWrapper);
      }
    }, 300);

    const findPaginationButton = setInterval(() => {
      if (document.querySelector('.pagination-wrapper .disable-last-page')) {
        //Disable last pagination button
        const paginationDisabledButton = document.querySelector('.pagination-wrapper .disable-last-page');
        paginationDisabledButton.setAttribute('disabled', true);
        paginationDisabledButton.setAttribute('tabindex', '-1');
        clearInterval(findPaginationButton);
      }
    }, 500);

    const findSelectedPaginationButton = setInterval(() => {
      if (document.querySelector('.pagination-wrapper')) {
        //Add aria-current to current pagination button
        const pageButtons = document.querySelectorAll('.pagination-wrapper .page-number-item');
        const selectedPageButton = document.querySelector('.pagination-wrapper .page-number-item-selected');
        selectedPageButton.setAttribute('aria-current','page');
        pageButtons.forEach(button => {
          button.addEventListener('click', (e) => {
            setTimeout(() => {
              pageButtons.forEach(btn => btn.removeAttribute('aria-current'));
              document.querySelector('.page-number-item-selected').setAttribute('aria-current', 'page');
            }, 1000);
          });
        });
        clearInterval(findSelectedPaginationButton);
      }
    }, 500);
  }

  if (document.querySelector('.pswp__button.pswp__counter')) {
    const pswpCounters = document.querySelectorAll('.pswp__button.pswp__counter');

    pswpCounters.forEach(pswpCounter => {
      const observer = new MutationObserver(() => {
        if (!pswpCounter.querySelector('.sr-only')) {
          const spanElement = document.createElement('span');
          spanElement.classList.add('sr-only');
          spanElement.textContent = 'Images';
          pswpCounter.appendChild(spanElement);
        }
      });

      observer.observe(pswpCounter, {
        childList: true,
        subtree: true,
      });
    });
  }

  if (document.querySelector('.custom-video-wrapper .custom-video')) {
    const videoImage = document.querySelectorAll('.custom-video-wrapper .custom-video video img');
    videoImage.forEach((img) => {
      img.setAttribute('alt','');
    });
  }

  if (document.querySelector('.form-notification.success')) {
    const successNotification = document.querySelector('.form-notification.success');
    successNotification.classList.add('focused-element');

    setTimeout(() => {
      successNotification.classList.remove('focused-element');
    }, 1500);
  }

  const headerMenuWithChildren = document.querySelectorAll('li.menu-item-has-children');

  const setHeaderSubMenuState = (menuItem, expanded) => {
    const menuItemButton = menuItem.querySelector(':scope > .toggle-button');
    const subMenu = menuItem.querySelector(':scope > .sub-menu');

    if (!menuItemButton || !subMenu) {
      return;
    }

    menuItemButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    subMenu.classList.toggle('visible-element', expanded);
  };

  headerMenuWithChildren.forEach((menuItem) => {
    const menuItemButton = menuItem.querySelector(':scope > .toggle-button');

    if (!menuItemButton) {
      return;
    }

    menuItemButton.addEventListener('click', function(event) {
      event.preventDefault();

      const openedByPointerHover = event.detail > 0 && menuItem.matches(':hover');
      const shouldExpand = openedByPointerHover || menuItemButton.getAttribute('aria-expanded') !== 'true';
      setHeaderSubMenuState(menuItem, shouldExpand);
    });

    menuItem.addEventListener('mouseenter', function() {
      setHeaderSubMenuState(menuItem, true);
    });

    menuItem.addEventListener('mouseleave', function() {
      setHeaderSubMenuState(menuItem, false);
    });
  });

  document.addEventListener('focusin', function (event) {
    const focusedElement = event.target;
    const visibleSubMenus = document.querySelectorAll('.sub-menu.visible-element');

    visibleSubMenus.forEach((subMenu) => {
      if (!subMenu.contains(focusedElement) && !subMenu.parentElement.contains(focusedElement)) {
        setHeaderSubMenuState(subMenu.parentElement, false);
      }
    });
  });

  const searchIcon = document.querySelector('.search-toggle.thb-secondary-area-item');
  if (searchIcon) {
    searchIcon.addEventListener('click', () => {
      setTimeout(() => {
        const searchDrawer = document.querySelector('.search-drawer');
        const searchClose = document.querySelector('.search-drawer .side-panel-close-button');
        if (searchDrawer?.classList.contains('active') && searchClose) {
          searchClose.focus({
            preventScroll: true
          });
        }
      }, 600);
    });
  }
});


window.CustomerStoreCredit = new class CustomerStoreCredit {
  constructor() {
    this.containers = document.querySelectorAll('.custom-account-store-credit-container');

    if (this.containers.length) {
      this.refresh();
    }
  }

  async refresh() {
    if (!this.containers.length) {
      return;
    }

    try {
      const response = await fetch('/apps/integration/customer/balances', {
        headers: {
          Accept: 'application/json'
        },
        credentials: 'same-origin'
      });

      if (!response.ok) {
        return;
      }

      const contentType = response.headers.get('content-type') || '';
      const responseText = await response.text();

      if (!contentType.includes('application/json')) {
        console.warn('Customer store credit endpoint returned non-JSON content.', {
          status: response.status,
          contentType
        });
        return;
      }

      const store_credit = JSON.parse(responseText);

      for (const $container of this.containers) {
        const $code = $container.querySelector('[data-gift-card-code]');
        const $credit_total = $container.querySelector('[data-store-credit-total]');
        const $credit_balance = $container.querySelector('[data-store-credit-balance]');

        const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

        $credit_total.textContent = formatter.format(parseFloat(store_credit.initialBalance));
        $credit_balance.textContent = formatter.format(parseFloat(store_credit.currentBalance));

        // First initialization only!
        if (!$container.classList.contains('active')) {
          const $show_button = $container.querySelector('.custom-account-store-credit-code a');
          const $copy_button = $container.querySelector('.custom-account-store-credit-code button');

          let is_visible = true;
          function toggleCode() {
            is_visible = !is_visible;

            $code.textContent = is_visible ? store_credit.code : `${store_credit.code.substr(0, 4)}...`;
            $show_button.querySelector('.text-button').textContent = is_visible ? 'Hide' : 'Show';
          }

          $copy_button.addEventListener('click', () => navigator.clipboard.writeText(store_credit.code));
          $show_button.addEventListener('click', () => toggleCode());

          $container.classList.add('active');
          toggleCode();
        }
      }
    } catch (error) {
      console.error('Unable to load customer store credit.', error);
    }
  }
};

/* Custom code to open mobile menu */
if (window.innerWidth < 1025) {
  const mobileMenuOpen = document.querySelector('.mobile-toggle-wrapper');
  const mobileMenu = document.querySelector('#mobile-menu');
  const closeMenuBtn = document.querySelector('[data-close-menu-mobile], [data-close-menu-mobile-accessibility]');

  const mobileMenuFirstItem = mobileMenu.querySelector('[data-close-menu-mobile-accessibility]');
  const mobileMenuLastItem = mobileMenu.querySelector('ul.mobile-menu a[title="A-List REWARDS"]');

  function openMenu() {
    mobileMenuOpen.setAttribute('open', true);
    mobileMenuOpen.setAttribute('aria-expanded', 'true');
    mobileMenu.setAttribute('aria-hidden', 'false');
    mobileMenu.classList.add('active-mobile-menu');
    closeMenuBtn.removeAttribute('hidden');
    mobileMenuOpen.setAttribute('hidden', true);
    document.body.classList.add('overflow-hidden');
    document.body.classList.add('mobile-menu-open');

    setTimeout(() => {
      mobileMenu.focus();
    }, 300);
  }

  function closeMenu() {
    mobileMenuOpen.removeAttribute('open');
    mobileMenuOpen.setAttribute('aria-expanded', 'false');
    mobileMenu.setAttribute('aria-hidden', 'true');
    mobileMenu.classList.remove('active-mobile-menu');
    mobileMenuOpen.focus();
    closeMenuBtn.setAttribute('hidden', true);
    mobileMenuOpen.removeAttribute('hidden');
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('mobile-menu-open');
  }

  mobileMenuOpen.addEventListener('click', (event) => {
    openMenu();
    //code here
    handleTabNavigation(mobileMenu, mobileMenuFirstItem, mobileMenuLastItem);
  });

  closeMenuBtn.addEventListener('click', closeMenu);
}

// No reviews text for OKE Star Rating
document.addEventListener("DOMContentLoaded", () => {
  const targetElement = document.querySelector(".product-price-flex [data-oke-star-rating]");

  if (!targetElement) return;

  const observer = new MutationObserver(() => {
      if (targetElement.hasAttribute("data-oke-rendered")) {
          const jsonScript = targetElement.querySelector("[data-oke-metafield-data]");
          if (jsonScript) {
              try {
                  const reviewData = JSON.parse(jsonScript.textContent.trim());
                  if (reviewData.reviewCount === 0) {
                      targetElement.classList.add("oke-no-reviews");
                      if(targetElement.querySelector('.oke-is-clickable')) {
                        targetElement.querySelector('.oke-is-clickable').innerHTML = `<span class="oke-no-reviews-text">No reviews yet</span>`;
                      }
                  }
              } catch (error) {
                  console.error("Error parsing review data:", error);
              }

              observer.disconnect();
          }
          
      }
  });

  observer.observe(targetElement, { attributes: true, attributeFilter: ["data-oke-rendered"] });
});

// Sticky ATC
function renderStickyAddToCartBtn() {
  const section = document.querySelector('product-add-to-cart-sticky');
  // Add to Cart - XL ($100)

  if (section) {
    const btnTextEl = section.querySelector('.single-add-to-cart-button--text');

    // Add variant text selector
    if (!btnTextEl.querySelector('.variant-text')) {
      const variantText = document.createElement('span');
      variantText.classList.add('variant-text');
      btnTextEl.appendChild(variantText);
    }

    const variantTextEl = btnTextEl.querySelector('.variant-text');

    // Get Price
    const priceEl = section.querySelector('.product-add-to-cart-sticky--info .price ins');
    const price = priceEl.textContent;

    let btnText = ` - `;

    // Get Selected Variant
    if (section.querySelector('variant-selects[data-options]')) {
      btnText += section.querySelector('variant-selects[data-options]').dataset.options;
    }

    // Set price
    btnText += ` (${price})`;
    
    // Set variant text
    variantTextEl.textContent = btnText;
  }
}

// Listen for variant change
document.addEventListener('stickyAddToCartTrigger', renderStickyAddToCartBtn);
document.addEventListener("product:variant-info-rendered", renderStickyAddToCartBtn);

// Product Drawer Accessibility
document.addEventListener("DOMContentLoaded", () => {
  const productDrawer = document.querySelector('.product-drawer');
  if (!productDrawer) return;

  let savedTitle = '';
  let lastFocusedElement = null;
  let productTitleElement = null;

  // Create observer for product drawer
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const drawer = mutation.target;

        // When drawer becomes active
        if (drawer.classList.contains('active')) {
          productTitleElement = drawer.querySelector('.product-title');
          lastFocusedElement = document.activeElement;

          const focusableElements = drawer.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          );

          setTimeout(() => {
            var dialog = document.querySelector('.side-panel.product-drawer.active');
            var firstFocusableElement = dialog.querySelector('.side-panel-close');
            var lastFocusableElement = dialog.querySelector('#AddToCart');

            // Add keydown event listener with new implementation
            drawer.addEventListener('keydown', function(e) {
              if (e.key === 'Tab') {
                if (e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
                  e.preventDefault();
                  lastFocusableElement.focus();
                } else if (e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
                  e.preventDefault();
                  firstFocusableElement.focus();
                }
              }
            });
          }, 200);
        }
        // When drawer becomes inactive
        else if (!drawer.classList.contains('active') && mutation.oldValue && mutation.oldValue.includes('active')) {
          if (productTitleElement) {
            savedTitle = productTitleElement.textContent.trim();
            // Find the matching product on the page
            setTimeout(() => {
              const matchingProducts = document.querySelectorAll('.title-container .product-title');
              for (const product of matchingProducts) {
                if (product.textContent.trim() === savedTitle) {
                  const matchedProductLink = product.closest('a');

                  matchedProductLink.focus();
                  break;
                }
              }
            }, 100);
          }
        }
      }
    });
  });

  observer.observe(productDrawer, {
    attributes: true,
    attributeFilter: ['class'],
    attributeOldValue: true
  });
});

if (window.innerWidth <= 768) {
  document.addEventListener("DOMContentLoaded", function (event) {
    let findFiltersInterval;
    let elapsedTime = 0;

    findFiltersInterval = setInterval(() => {
      const filtersButtonWrapper = document.querySelector('.filters-button-wrapper');
      elapsedTime += 100;

      if (filtersButtonWrapper) {
        filtersButtonWrapper.addEventListener('click', () => {
          setTimeout(() => {
            const categoryTitle = document.querySelector('.category-title');
            const filtersModalWrapper = document.querySelector('.filters-modal-wrapper');
            const closeButton = document.createElement('button');
            closeButton.innerHTML = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="close-icon">
              <title id="close-icon">Close Modal Icon</title>
              <path d="M13 1L1 13M13 13L1 1" stroke="var(--color-body)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>`;
            closeButton.classList.add('close-filters-button');
            closeButton.setAttribute('type', 'button');
            closeButton.setAttribute('aria-label', 'Close filters');

            closeButton.addEventListener('click', () => {
              filtersModalWrapper.remove();
              closeButton.remove();
            });

            categoryTitle.appendChild(closeButton);
            closeButton.focus();
          }, 200);
        });

        clearInterval(findFiltersInterval);
      }

      if (elapsedTime >= 4000) {
        clearInterval(findFiltersInterval);
      }
    }, 400);
  });
}

// Announcement Bar Marquee Pause Animation
document.addEventListener("DOMContentLoaded", function (event) {
  setTimeout(() => {
    const announcementMarquee = document.querySelector('.announcement-layout--marquee');
    if (announcementMarquee) {
      announcementMarquee.classList.add('pause-animation');
    }
  }, 5000);

  const mobileMenu = document.querySelectorAll('details.link-container');
  mobileMenu.forEach(menu => {
    menu.addEventListener('click', () => {
      setTimeout(() => {
        const menuFirstItem = menu.querySelector(('.sub-menu button:first-child'));
        menuFirstItem.focus();
      }, 200);
    });
  });
});

// Video pause / play functionality
document.addEventListener("DOMContentLoaded", function () {
  // Get all pause/play buttons
  var pauseButtons = document.querySelectorAll('.pause-button');

  pauseButtons.forEach(function (pauseButton) {
    let playing = true;
    let autoStopTimer;
    let slideshowSlide = pauseButton.closest('.slideshow__slide');
    let videoDom = slideshowSlide.querySelector('video');

    function pauseSlideshow(autoPaused = false) {
      pauseButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"/></svg>`;
      pauseButton.setAttribute('aria-label', 'Play video');
      playing = false;
      if (videoDom) videoDom.pause();
    }

    function playSlideshow() {
      pauseButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"/></svg>`;
      pauseButton.setAttribute('aria-label', 'Pause video');
      playing = true;
      if (videoDom) {
        videoDom.play();
        clearTimeout(autoStopTimer);
        autoStopTimer = setTimeout(function () {
          pauseSlideshow(true);
        }, 5000);
      }
    }

    pauseButton.onclick = function () {
      if (playing) {
        pauseSlideshow();
        clearTimeout(autoStopTimer);
      } else {
        playSlideshow();
      }
    };

    // Auto-start video and stop after 5 seconds
    if (videoDom) {
      videoDom.play();
      autoStopTimer = setTimeout(function () {
        pauseSlideshow(true);
      }, 5000);
    }
  });
});
/**
 * Enables horizontal drag-to-scroll with momentum + click suppression.
 * @param {Element} scroller - The container element with overflow-x.
 * @param {Object} options - Configurable settings.
 * @param {number} [options.threshold=6] - Min px movement before drag starts.
 * @param {number} [options.friction=0.94] - Momentum decay per frame.
 * @param {number} [options.pressDelay=100] - ms hold before "pressing" is active.
 */
function enableDragScroll(scroller, {
  threshold = 6,
  friction = 0.94,
  pressDelay = 100
} = {}) {
  let isDown = false;
  let startX = 0;
  let startScroll = 0;
  let prevScroll = 0;
  let velX = 0;
  let momentumID = null;
  let moved = false;
  let pressingActive = false;
  let pressTimer = null;

  // --- Utils ---
  const stopMomentum = () => {
    if (momentumID) cancelAnimationFrame(momentumID);
    momentumID = null;
    velX = 0;
  };

  const momentum = () => {
    scroller.scrollLeft += velX;
    velX *= friction;
    if (Math.abs(velX) > 0.5) {
      momentumID = requestAnimationFrame(momentum);
    }
  };

  const resetPressing = () => {
    clearTimeout(pressTimer);
    scroller.classList.remove('pressing');
    pressingActive = false;
  };

  // --- Handlers ---
  const onMouseDown = (e) => {
    if (e.button !== 0) return; // left click only
    isDown = true;
    startX = e.clientX;
    startScroll = scroller.scrollLeft;
    prevScroll = scroller.scrollLeft;
    moved = false;
    pressingActive = false;

    stopMomentum();
    document.body.style.userSelect = 'none';

    // Add pressing class after delay
    pressTimer = setTimeout(() => {
      pressingActive = true;
      scroller.classList.add('pressing');
    }, pressDelay);
  };

  const onMouseMove = (e) => {
    if (!isDown) return;

    const dx = e.clientX - startX;
    if (!moved && Math.abs(dx) > threshold) {
      moved = true;
      scroller.classList.add('dragging');
    }

    if (moved) {
      e.preventDefault();
      scroller.scrollLeft = startScroll - dx;
      velX = scroller.scrollLeft - prevScroll;
      prevScroll = scroller.scrollLeft;
    }
  };

  const onMouseUp = () => {
    if (!isDown) return;
    isDown = false;

    clearTimeout(pressTimer);

    if (moved) {
      scroller.classList.remove('dragging');
      momentum();
    }

    resetPressing();
    document.body.style.userSelect = '';
  };

  const onClick = (e) => {
    if (moved || pressingActive) {
      e.preventDefault(); // block click navigation
      e.stopImmediatePropagation();
    }
  };

  // --- Bind events ---
  scroller.addEventListener('mousedown', onMouseDown);
  document.addEventListener('mousemove', onMouseMove);
  document.addEventListener('mouseup', onMouseUp);
  scroller.addEventListener('click', onClick, true);
}


/* Custom JS */
document.addEventListener('DOMContentLoaded', function () {
  // Select navigation
  const nav = document.querySelector('.full-menu nav');
  const menu = nav.querySelector('.thb-full-menu');

  // Ensure menu has ID
  if (!menu.id) {
    menu.id = 'menu';
  }

  // Create and insert arrows
  const arrows = document.createElement('div');
  arrows.className = 'arrows';
  arrows.innerHTML = `
    <button id="left-arrow" class="left-arrow arrow hidden" aria-label="Scroll left">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M9.32813 3.5L5.82813 7L9.32812 10.5" stroke="white" stroke-width="1.28333" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <button id="right-arrow" class="right-arrow arrow" aria-label="Scroll right">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M5.82812 3.5L9.32812 7L5.82812 10.5" stroke="white" stroke-width="1.28333" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  `;
  nav.appendChild(arrows);

  // DOM elements to track
  const leftArrow = document.getElementById('left-arrow');
  const rightArrow = document.getElementById('right-arrow');
  if (!leftArrow || !rightArrow) {
    console.error('Arrow buttons not found');
    return;
  }

  // Initialize constants and variables
  let menuWrapperSize = nav.offsetWidth;
  let menuSize = menu.offsetWidth;
  let menuInvisibleSize = Math.max(menuSize - menuWrapperSize, 0);
  let arrowSize = rightArrow.offsetWidth;
  let menuEndOffset = Math.max(menuInvisibleSize - arrowSize, 0);
  const itemsCount = document.getElementsByClassName('menu-item-has-children').length;
  const gap = 16;
  const durationInMilliseconds = 150;
  let starttime = null;

  // Helpers
  const getMenuLeft = () => parseFloat(menu.style.left) || 0;

  const setMenuLeft = (val) => {
    // Clamp: visible window is [ -menuInvisibleSize, 0 ]
    const clamped = Math.max(-menuInvisibleSize, Math.min(0, val));
    menu.style.left = clamped.toFixed(2) + 'px';
  };

  const getScrolledDistance = () => -1 * getMenuLeft();

  const recalcSizes = () => {
    menuWrapperSize = nav.offsetWidth;
    menuSize = menu.offsetWidth;
    menuInvisibleSize = Math.max(menuSize - menuWrapperSize, 0);
    arrowSize = rightArrow.offsetWidth;
    menuEndOffset = Math.max(menuInvisibleSize - arrowSize, 0);
  };

  const checkPosition = () => {
    recalcSizes();
    const menuPosition = getScrolledDistance();
    const tolerance = 1;

    if (menuInvisibleSize === 0) {
      leftArrow.classList.add('hidden');
      rightArrow.classList.add('hidden');
      return;
    }

    if (menuPosition <= tolerance) {
      leftArrow.classList.add('hidden');
      rightArrow.classList.remove('hidden');
    } else if (menuPosition < menuEndOffset - tolerance) {
      leftArrow.classList.remove('hidden');
      rightArrow.classList.remove('hidden');
    } else {
      leftArrow.classList.remove('hidden');
      rightArrow.classList.add('hidden');
    }
  };

  // Hide arrows if no overflow initially
  if (menuInvisibleSize === 0) {
    rightArrow.classList.add('hidden');
    leftArrow.classList.add('hidden');
  }

  const animateMenu = (timestamp, startingPoint, distance) => {
    const runtime = timestamp - starttime;
    let progress = runtime / durationInMilliseconds;
    progress = Math.min(progress, 1);
    const newValue = startingPoint + (distance * progress);
    setMenuLeft(newValue);

    if (runtime < durationInMilliseconds) {
      requestAnimationFrame(function (ts) {
        animateMenu(ts, startingPoint, distance);
      });
    }
    checkPosition();
  };

  const animationFramesSetup = (timestamp, travelDistanceInPixels) => {
    timestamp = timestamp || Date.now();
    starttime = timestamp;
    const startingPoint = getMenuLeft();
    const firstItem = document.getElementsByClassName('menu-item-has-children')[0];
    const itemSize = firstItem ? firstItem.offsetWidth : 0;
    const distance = travelDistanceInPixels > 0 ? itemSize + gap : -(itemSize + gap);
    requestAnimationFrame((ts) => animateMenu(ts, startingPoint, distance));
  };

  // Arrow click handlers
  rightArrow.addEventListener('click', () => {
    requestAnimationFrame(ts => animationFramesSetup(ts, -1));
  });
  leftArrow.addEventListener('click', () => {
    requestAnimationFrame(ts => animationFramesSetup(ts, 1));
  });

  // ------- Drag / Swipe to Scroll -------
  let isDragging = false;
  let dragStartX = 0;      // clientX when drag starts
  let dragStartLeft = 0;   // menu left when drag starts
  let movedPixels = 0;     // track movement to cancel clicks on drag
  const CLICK_CANCEL_THRESHOLD = 5;

  const onPointerDown = (clientX) => {
    isDragging = true;
    dragStartX = clientX;
    dragStartLeft = getMenuLeft();
    movedPixels = 0;
    menu.classList.add('dragging');
    // Disable smooth animation while dragging (if any CSS applies)
  };

  const onPointerMove = (clientX) => {
    if (!isDragging) return;
    const delta = clientX - dragStartX;
    movedPixels = Math.max(movedPixels, Math.abs(delta));
    setMenuLeft(dragStartLeft + delta);
    checkPosition();
  };

  const onPointerUp = () => {
    isDragging = false;
    menu.classList.remove('dragging');
  };

  // Mouse
  menu.addEventListener('mousedown', (e) => {
    // Only left-click
    if (e.button !== 0) return;
    onPointerDown(e.clientX);
  });

  window.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    e.preventDefault(); // prevent text/image drag ghost
    onPointerMove(e.clientX);
  });

  window.addEventListener('mouseup', () => {
    if (!isDragging) return;
    onPointerUp();
  });

  // Prevent accidental clicks on links when dragging
  menu.addEventListener('click', (e) => {
    if (movedPixels > CLICK_CANCEL_THRESHOLD) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  // Touch
  menu.addEventListener('touchstart', (e) => {
    if (!e.touches || !e.touches.length) return;
    const t = e.touches[0];
    onPointerDown(t.clientX);
  }, { passive: true });

  menu.addEventListener('touchmove', (e) => {
    if (!e.touches || !e.touches.length || !isDragging) return;
    const t = e.touches[0];
    onPointerMove(t.clientX);
  }, { passive: true });

  menu.addEventListener('touchend', () => {
    if (!isDragging) return;
    onPointerUp();
  }, { passive: true });

  menu.addEventListener('touchcancel', () => {
    if (!isDragging) return;
    onPointerUp();
  }, { passive: true });

  // Initial position check
  checkPosition();

  // Recalculate on window resize and keep position clamped
  window.addEventListener('resize', () => {
    recalcSizes();
    setMenuLeft(getMenuLeft()); // clamp to new bounds
    checkPosition();
  });
});
